export default __webpack_public_path__ + "static/media/section1-item-3.140fe143.png";